import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const PRODUCT_CONFIGURATION: OnboardingStep[] = [
    {
        className: OnboardingClasses.GROUP_TOUR_TOGGLE,
        title: 'Group Tour',
        placement: 'right-start',
        borderRadius: 18,
        content: `
                Toggle this on if a single event can be booked by multiple
                customers.
            `,
    },
    {
        className: OnboardingClasses.AUTOSCALE_TOGGLE,
        title: 'Autoscaled',
        placement: 'right-start',
        borderRadius: 18,
        content: `
                Toggle this on to allow multiple events of this product to be
                scheduled at the same or overlapping time.
            `,
    },
];
